import { RandomToken } from '@sibevin/random-token'

export default {
	methods: {
		generateAxiosToken () {
			const array = process.env.VUE_APP_TOKEN_ARRAY.split(',')
			const length = array[Math.floor(Math.random() * array.length)]
			return RandomToken.gen({
				length: length,
				mask: process.env.VUE_APP_TOKEN_MASK
			})
		}
	}
}
